export function loadAiLiveChat(debug = false) {
  if (typeof window === 'undefined') return;

  const scriptId = 'ai-search-next-script';
  const cacheBuster = Date.now().toString();
  const hostname = window.location.hostname.toLowerCase();
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isTestHost = hostname
    .split(/[.-]/)
    .some((part) => part === 'sit' || part === 'uat');
  const apiEnv = debug || isLocalHost || isTestHost
    ? 'test'
    : 'production';
  const scriptBaseUrl = debug
    ? 'http://10.10.10.11:3020'
    : 'https://static.crazysales.com.au/shop-helper-kit';
  const widgetSrc = `${scriptBaseUrl}/widget/live-chat-widget.js?_t=${cacheBuster}`;
  const params = new URLSearchParams({
    site: 'crazysales',
    apiEnv,
    width: '440px',
    height: '100vh',
    top: '0',
    right: '0',
    _t: cacheBuster,
    widgetSrc,
  });
  const src = `${scriptBaseUrl}/live-chat-next.js?${params.toString()}`;
  const oldScript = document.getElementById(scriptId);

  if (oldScript) oldScript.remove();

  const aiLiveChatJs = document.createElement('script');
  aiLiveChatJs.id = scriptId;
  aiLiveChatJs.src = src;
  aiLiveChatJs.async = true;
  aiLiveChatJs.onload = () => console.log('[ai-search] Script injected successfully:', src);
  aiLiveChatJs.onerror = (error) => console.error('[ai-search] Script injection failed:', src, error);

  document.head.appendChild(aiLiveChatJs);
}
